import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { usePapaParse } from 'react-papaparse';

import { addErrorNotification } from '../../../../slice/notificationsSlice';

import './FileDropZone.css';

function FileDropZone(props) {
  const { setter, type } = props;
  const [isDragging, setIsDragging] = useState(false);
  const { readString } = usePapaParse();

  const onDragEnter = () => setIsDragging(true);
  const onDragLeave = () => setIsDragging(false);

  const onUploadCsv = async(e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validCsvTypes = ['text/csv', 'application/vnd.ms-excel'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!validCsvTypes.includes(file.type) && fileExtension !== 'csv') {
      addErrorNotification('Only .csv files are allowed.');
      e.target.value = '';
      setIsDragging(false);
      return;
    }

    try {
      readString(await file.text(), {
        skipEmptyLines: true,
        complete: (results) => {
          setter(results.data);
        }
      });
    } catch (e) {
      addErrorNotification('The file uploaded is not in CSV format!');
      setIsDragging(false);
    }
  };

  const acceptedImageTypes = new Set(['image/jpeg', 'image/png']);

  const onUploadImg = e => {
    const img = e.target.files[0];
    if (!img) return;

    if (!acceptedImageTypes.has(img.type)) {
      addErrorNotification('Image must be in .png or .jpg format');
      return;
    }
    setter(img);
  };

  const acceptedTypes =
    type === 'csv'
      ? '.csv,text/csv,application/vnd.ms-excel'
      : 'image/png,image/jpeg';

  return (
    <div className='file-drop-zone' style={{ opacity: isDragging ? 0.4 : 1 }}>
      <input onDragEnter={onDragEnter} onDragLeave={onDragLeave} type='file' accept={acceptedTypes} onChange={type === 'csv' ? onUploadCsv : onUploadImg}/>
      <div><b>Click or drag {type === 'csv' ? 'a csv' : 'an image'} file to this area to upload</b></div>
    </div>
  );
}

FileDropZone.propTypes = {
  setter: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['csv', 'img']).isRequired
};

export default FileDropZone;
